export const capabilities = [
  {
    slug: 'enterprise-risk-intelligence',
    title: 'Enterprise Risk Intelligence',
    summary: 'Horizon scanning, emerging risk signals, and board-ready intelligence that turns uncertainty into actionable foresight.',
    body: 'Organizations today face concurrent threats—cyber, climate, geopolitical, regulatory, and operational. Enterprise Risk Intelligence gives leadership a clear, continuous view of what matters most. We combine structured diagnostics with ongoing scanning so risk conversations move from reactive firefighting to anticipatory decision-making. Our approach integrates qualitative insight with quantitative exposure views, enabling prioritization that aligns with strategy, capital, and operational reality.',
  },
  {
    slug: 'insurance-architecture',
    title: 'Insurance Architecture',
    summary: 'Insurance designed as a strategic layer within your protection architecture—not a standalone transactional purchase.',
    body: 'Insurance remains essential—but alone it is no longer enough. We design insurance architectures that fit inside a broader resilience strategy: coverage that maps to quantified exposure, structures that support continuity, and programs that evolve with your risk profile. The goal is confidence and continuity, not merely placement.',
  },
  {
    slug: 'cyber-resilience',
    title: 'Cyber Resilience',
    summary: 'From exposure visibility to response readiness—building organizations that absorb and recover from digital disruption.',
    body: 'Cyber risk is an enterprise resilience challenge spanning technology, people, third parties, and continuity. We help organizations assess exposure, strengthen protective controls in context, and prepare response and recovery pathways—so digital disruption does not become existential disruption.',
  },
  {
    slug: 'supply-chain-resilience',
    title: 'Supply Chain Resilience',
    summary: 'Mapping critical dependencies and designing continuity strategies for multi-tier disruption scenarios.',
    body: 'Modern supply chains are complex networks of concentration risk. We help identify critical nodes, stress-test continuity assumptions, and design protective and recovery measures that keep operations moving when upstream or downstream partners fail.',
  },
  {
    slug: 'operational-resilience',
    title: 'Operational Resilience',
    summary: 'Ensuring critical services continue through disruption—people, processes, facilities, and technology.',
    body: 'Operational resilience is the ability to deliver critical outcomes under stress. We assess single points of failure, design continuity and crisis frameworks, and align insurance and technology layers so operations recover with speed and discipline.',
  },
  {
    slug: 'climate-risk',
    title: 'Climate Risk',
    summary: 'Physical and transition risk insight that informs resilience planning, capital decisions, and continuity design.',
    body: 'Climate events and transition pressures reshape exposure for assets, operations, and supply chains. We help organizations understand climate-related risk in business terms and integrate it into resilience architecture and protection strategy.',
  },
  {
    slug: 'digital-risk',
    title: 'Digital Risk',
    summary: 'Risk intelligence for digital transformation—platforms, data, third parties, and emerging technology.',
    body: 'As organizations digitize, new failure modes appear. Digital Risk capability brings structured assessment of platforms, data integrity, vendor ecosystems, and technology change—so digital ambition is paired with digital readiness.',
  },
  {
    slug: 'claims-intelligence',
    title: 'Claims Intelligence',
    summary: 'Orchestrated claims and recovery support that accelerates outcomes and protects operational continuity.',
    body: 'When loss occurs, speed and clarity matter. Claims Intelligence coordinates response, documentation, stakeholder communication, and recovery pathways—turning a claims event into a managed resilience activation rather than a prolonged disruption.',
  },
  {
    slug: 'business-continuity',
    title: 'Business Continuity',
    summary: 'Continuity planning, crisis playbooks, and recovery design for organizations that must keep operating.',
    body: 'Business continuity is the backbone of resilience. We design and refine continuity frameworks, crisis management structures, and recovery priorities so leadership knows what to activate—and how—when disruption arrives.',
  },
  {
    slug: 'ai-risk',
    title: 'AI Risk',
    summary: 'Governance and resilience for AI adoption—model risk, data risk, and operational accountability.',
    body: 'AI creates opportunity and new classes of risk. We help organizations frame AI risk within enterprise resilience: governance, accountability, failure modes, and protective architecture that supports responsible, resilient adoption.',
  },
  {
    slug: 'health-workforce-resilience',
    title: 'Health & Workforce Resilience',
    summary: 'Protecting the people and health systems that keep organizations and communities functioning.',
    body: 'Workforce and health system resilience is foundational. Drawing on healthcare and workforce insight, we help organizations design protection and continuity strategies that safeguard people, capacity, and critical service delivery.',
  },
  {
    slug: 'resilience-analytics',
    title: 'Resilience Analytics',
    summary: 'Scorecards, dashboards, and monitoring that make resilience measurable and improvable over time.',
    body: 'What gets measured improves. Resilience Analytics provides maturity scorecards, monitoring views, and insight loops so organizations can track progress, prioritize investment, and demonstrate readiness to boards and stakeholders.',
  },
];

export const getCapabilityBySlug = (slug) =>
  capabilities.find((c) => c.slug === slug);
